import { defineComponent as g, computed as b, createBlock as s, openBlock as t, withCtx as y, createVNode as i, createElementBlock as a, createCommentVNode as r, unref as o, normalizeClass as h, createElementVNode as k, toDisplayString as l } from "vue";
import { RevButtonIcon as v } from "@ds/components/ButtonIcon";
import x from "../../../icons/generated/IconCross.vue2.js";
import w from "../../../icons/generated/IconWarning.vue2.js";
import { tw as m } from "../../../utils/tailwind.js";
import B from "./DocumentLabelWrapper.vue2.js";
import C from "./DocumentName.vue2.js";
const M = { class: "flex" }, $ = {
  key: 0,
  class: "text-static-danger-hi caption-bold truncate"
}, p = {
  key: 1,
  class: "text-static-danger-hi grow truncate py-8"
}, R = /* @__PURE__ */ g({
  name: "DocumentError",
  __name: "DocumentError",
  props: {
    name: {},
    errorMessage: {},
    deletable: { type: Boolean },
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(e, { emit: c }) {
    const d = e, u = c, f = b(() => [
      m`ml-0 mr-auto overflow-hidden`,
      !d.errorMessage && m`py-8`
    ]);
    return (E, n) => (t(), s(B, { class: "border-static-danger-hi flex w-full grow items-center justify-between border" }, {
      default: y(() => [
        i(o(w), { class: "text-static-danger-hi" }),
        e.name ? (t(), a("div", {
          key: 0,
          class: h(f.value)
        }, [
          k("div", M, [
            i(C, { name: e.name }, null, 8, ["name"])
          ]),
          e.errorMessage ? (t(), a("div", $, l(e.errorMessage), 1)) : r("", !0)
        ], 2)) : r("", !0),
        !e.name && e.errorMessage ? (t(), a("span", p, l(e.errorMessage), 1)) : r("", !0),
        e.deletable ? (t(), s(o(v), {
          key: 2,
          "aria-label": e.deleteButtonAriaLabel,
          icon: o(x),
          variant: "secondary",
          onClick: n[0] || (n[0] = (N) => u("delete"))
        }, null, 8, ["aria-label", "icon"])) : r("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  R as default
};
